import { gql } from '@apollo/client'

export const GET_VISIBLE_TRANSFER_OFFERS = gql`
  query GetVisibleTransferOffers($fantasyLeagueId: ID!) {
    visibleTransferOffers(fantasyLeagueId: $fantasyLeagueId) {
      id
      amount
      status
      createdAt
      player {
        id
        createdAt
        nick
        name
        lastName
        role
        marketValue
        image
        totalScore
        lastWeekScore
        lastWeekNumber
        team {
          id
          competition {
            id
            code
            displayName
            rank
          }
          createdAt
          nameShow
          shortName
          shield
        }
      }
      bidder {
        id
        teamName
      }
      seller {
        id
        teamName
      }
    }
  }
`
